import React, { useEffect, useState, useMemo } from "react";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom"
import ToastDialog from "components/Common/ToastDialog";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Nav,
    NavItem,
    Row,
    TabContent,
    TabPane,
    NavLink
} from "reactstrap";

//Import Breadcrumb
import TableContainerV1 from "components/Common/TableContainerV1";
import { callgetFileByFileId, callGetAllFileData, callGetAllFileDataCount, callUplodBulkOrderReq, callgetFileById } from "http/auth/signup";
import classnames from "classnames"
import { isPermission } from "common/utility";

const BulkOrderStatusEmp = () => {
    const navigate = useNavigate();
    document.title = "Order Status | DMS";
    const [userList, setUserList] = useState([]);
    const [fileCount, setFileCount] = useState(null);
    const [loading, setLoading] = useState(false)
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageCount: 0,
        totalRecords: 0,
    });
    const [fileStatus, setfileStatus] = useState(true);
    const [columnId, setColumnId] = useState("id");
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const urlParams = new URLSearchParams(window.location.search)
    const user = JSON.parse(localStorage.getItem("user"));
    const [toastInfo, setToastInfo] = useState({ showToast: false })
    const encodedId = urlParams.get("id")
    const decodedId = atob(encodedId)
    const [sortingOptions, setSortingOptions] = useState({
        column: "id",
        isAsc: false,
        optionalColumn: ["Action", "productCode", "quantity", "price", "lastName"],
    });
    const [customActiveTab, setCustomActiveTab] = useState("1")
    const [status, setStatus] = useState(1);
    const [uploadPermission, setUploadPermission] = useState(false);


    const toggleCustom = tab => {
        if (customActiveTab != tab) {
            setCustomActiveTab(tab)
            setStatus(tab)
        }
    }

    const columns = useMemo(
        () => [
            {
                Header: 'Batch Id',
                accessor: 'batchId',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || 'NA';
                }
            },
            {
                Header: 'Product Code',
                accessor: 'productCode',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.productCode || 'NA';
                }
            },
            {
                Header: 'Quantity',
                accessor: 'quantity',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.quantity || 'NA';
                }
            },
            {
                Header: 'Price',
                accessor: 'price',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return formatNumberWithCommas(rowData.fileData?.sellingPrice) || 'NA';
                }
            },
            {
                Header: 'Field Error',
                accessor: 'errorValue',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || 'NA'
                }
            },
        ],
        []
    );

    const columns2 = useMemo(
        () => [
            {
                Header: 'Id',
                accessor: 'id',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                }
            },
            {
                Header: 'Batch Id',
                accessor: 'batchId',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || 'NA';
                }
            },
            {
                Header: 'Product Code',
                accessor: 'productCode',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.productCode || 'NA';
                }
            },
            {
                Header: 'Quantity',
                accessor: 'quantity',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.quantity || 'NA';
                }
            },
            {
                Header: 'Price',
                accessor: 'price',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return formatNumberWithCommas(rowData.fileData?.sellingPrice) || 'NA';
                }
            },
        ],
        []
    );

    const getUserList = async (body) => {
        const response = await callgetFileByFileId(body);
        if (response.status) {
            setUserList(response.data.data);
            const { totalItems, totalPages, currentPage } = response.data
            setPagination({
                pageIndex: currentPage,
                pageCount: totalPages,
                totalRecords: totalItems,
            })
        } else {
            setUserList([]);
            setPagination({
                pageIndex: 0,
                pageCount: 0,
                totalRecords: 0,
            })
        }
    }

    useEffect(() => {
        checkPermissions()
        getDataCount()
        getFileStatus()
    }, []);

    useEffect(() => {
        const bodyData = {
            page: 1,
            batch: decodedId,
            status,
        }
        getUserList(bodyData);
    }, [status]);

    const getDataCount = async () => {
        const response = await callGetAllFileDataCount({
            dataType: 'order_emp',
            batchId: decodedId
        })
        if (response.status) {
            setFileCount(response.data)
        }
    }

    const getFileStatus = async () => {
        let fileDetails = await callgetFileById({ id: decodedId })
        if (fileDetails.status) {
            setfileStatus(fileDetails.data.status != 1)
        }
    }

    const handlePageChange = (
        page,
        pageSize,
        searchKey,
        columnName = columnId,
        sortingOrder = sortingOrderStatus
    ) => {
        getUserList({ page, limit: pageSize, batch: decodedId, columnName, sortingOrder, status })
    }

    const handleSortColumn = (option) => {
        setSortingOptions(option);
        const columnName = option.column;
        setColumnId(columnName);
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder);
        getUserList({ page: 1, columnName, sortingOrder, status, batch: decodedId, })
    };

    const checkPermissions = async () => {
        const isUploadPermission = await isPermission("bulk_upload_orders", "upload_permission")
        setUploadPermission(isUploadPermission)
    }

    const bulkAddToCart = async (orderBody) => {
        setLoading(true)
        const result = await callUplodBulkOrderReq(orderBody)
        if (result.status) {
            setLoading(false)
            setToastInfo({
                message: result.message,
                showToast: true,
                role: "success",
            })
            setTimeout(() => {
                navigate(`/${user.roleName}/orders`)
            }, 1000)
        } else {
            setLoading(false)
            setToastInfo({
                message: result.message || 'Failed to add in cart',
                showToast: true,
                role: "error",
            })
        }
    }

    const buttonSection = (
        <div className="text-sm-end">
            {userList.length > 0 && customActiveTab == 3 && (<Button
                type='submit'
                color='success'
                style={{ padding: '8px', borderRadius: '50%', width: '40px', height: '40px' }}
                onClick={() => { createAndDownloadExcel('Orders', status, decodedId) }}
            >
                <i className='bx bx-download'></i>
            </Button>)}
            {userList.length > 0 && customActiveTab == 2 && !fileStatus && uploadPermission && (<Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={() => { bulkAddToCart({ batchId: decodedId }) }}
            >
                {loading && (
                    <span
                        className="spinner-border spinner-border-sm ms-2 me-2"
                        role="status"
                        aria-hidden="true"
                    ></span>
                )
                }
                {!loading && (
                    <>
                        <i className="mdi mdi-cart me-1" />
                        {'Place Order Request'}
                    </>
                )}
                {loading && (
                    <>
                        {'Placing Order Request'}
                    </>
                )}
            </Button>)}
        </div>
    )
    return (
        <div className="page-content">
            <Container fluid >
                <div className='page-title-box d-flex gap-3 justify-content-between align-items-center'>
                    <h4 className="mb-sm-0 font-size-18">ORDER STATUS</h4>
                    <div className="d-flex gap-3 justify-content-end">
                        <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={() => { navigate(-1) }}
                        >
                            {'Back'}
                        </button>
                    </div>
                </div>
                <Row className="vertical-scroll">
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <Nav tabs className="nav-tabs-custom nav-justified">
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "1",
                                            })}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleCustom("1")
                                            }}
                                        >
                                            <span className="d-block d-sm-none">
                                                <i className="fas fa-home"></i>
                                            </span>
                                            <span className="d-none d-sm-block">
                                                All Records({fileCount?.completedBatchDataCount})
                                            </span>
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "2",
                                            })}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleCustom("2")
                                            }}
                                        >
                                            <span className="d-block d-sm-none">
                                                <i className="far fa-user"></i>
                                            </span>
                                            <span className="d-none d-sm-block">
                                                Successfully Completed Records({fileCount?.pendingBatchDataCount})
                                            </span>
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "3",
                                            })}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleCustom("3")
                                            }}
                                        >
                                            <span className="d-block d-sm-none">
                                                <i className="far fa-user"></i>
                                            </span>
                                            <span className="d-none d-sm-block">
                                                Failed Records({fileCount?.errorBatchDataCount})
                                            </span>
                                        </NavLink>
                                    </NavItem>

                                </Nav>
                                <TabContent
                                    activeTab={customActiveTab}
                                    className="p-3 text-muted"
                                >
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col>
                                                <TableContainerV1
                                                    columns={columns}
                                                    data={userList}
                                                    pagination={pagination}
                                                    handlePageChange={handlePageChange}
                                                    // handleSearchFilter={handleSearchFilter}
                                                    sortOptions={sortingOptions}
                                                    customSection={buttonSection}
                                                    handleSortColumn={handleSortColumn}
                                                    // handleClearSearch={handleClearSearch}
                                                    className="custom-header-css"
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col>
                                                <TableContainerV1
                                                    columns={columns2}
                                                    data={userList}
                                                    pagination={pagination}
                                                    handlePageChange={handlePageChange}
                                                    // handleSearchFilter={handleSearchFilter}
                                                    sortOptions={sortingOptions}
                                                    customSection={buttonSection}
                                                    handleSortColumn={handleSortColumn}
                                                    // handleClearSearch={handleClearSearch}
                                                    className="custom-header-css"
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Row>
                                            <Col>
                                                <TableContainerV1
                                                    columns={columns}
                                                    data={userList}
                                                    pagination={pagination}
                                                    handlePageChange={handlePageChange}
                                                    // handleSearchFilter={handleSearchFilter}
                                                    sortOptions={sortingOptions}
                                                    customSection={buttonSection}
                                                    handleSortColumn={handleSortColumn}
                                                    // handleClearSearch={handleClearSearch}
                                                    className="custom-header-css"
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ToastDialog
                message={toastInfo.message}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
        </div>
    );
};

export default BulkOrderStatusEmp;

const createAndDownloadExcel = async (fileName, status, id) => {
    const response = await callGetAllFileData({ fileId: id, status: status });
    if (response.status) {
        let newData = response.data.rows.map((ele) => {
            return {
                productCode: ele.fileData.productCode || '',
                quantity: ele.fileData.quantity || '',
            }
        })
        const ws = XLSX.utils.json_to_sheet(newData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        const buffer = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'array' });
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.download = `${fileName}.xlsx`;
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

const formatNumberWithCommas = (number) => {
    if (number) {
        const formattedNumber = number.toString().replace(/\./, ',');
        const parts = formattedNumber.split(',');
        if (parts[0].length > 3) {
            const lastThree = parts[0].substr(parts[0].length - 3);
            const remaining = parts[0].slice(0, parts[0].length - 3);
            parts[0] = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
        }
        return '₹' + parts.join('.');
    }
}